<!--
 * @Description:
 * @Author: git config user.name
 * @Date: 2025-09-09 09:56:46
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-15 15:05:21
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\feedBack\components\view-dialog.vue
-->
<template>
	<el-dialog title="反馈处理" :visible.sync="dialog.visible" :close-on-click-modal="false" width="800px" append-to-body>
		<div v-if="dialog.visible">
			<div v-if="dialog.type == 'check' || status == 1 || status == 2">
				<el-tabs v-model="activeTabIndex" @tab-click="tabChange(activeTabIndex)">
					<el-tab-pane name="0">
						<span slot="label">{{ status == 1 || status == 2 ? '反馈详情' : '处理' }}</span>
					</el-tab-pane>
					<el-tab-pane name="1">
						<span slot="label">处理记录 </span>
					</el-tab-pane>
				</el-tabs>
			</div>
			<div v-if="activeTabIndex == 0">
				<el-form :model="baseForm" :rules="baseRules" ref="baseForm" label-width="80px" class="base-form mt-20">
					<el-form-item label="更新状态" prop="status" v-if="dialog.type == 'check'">
						<el-select v-model="baseForm.status" placeholder="请选择" clearable>
							<el-option :value="0" label="处理中"></el-option>
							<el-option :value="1" label="已解决"></el-option>
							<el-option :value="2" label="已关闭"></el-option>
						</el-select>
					</el-form-item>
					<!-- 正整数 0-30；只有状态为处理中才显示 -->
					<el-form-item label="处理时长" prop="dealHour" v-if="dialog.type == 'check' && baseForm.status === 0">
						<el-input type="number" v-model="baseForm.dealHour" size="small" min="0" max="30" placeholder="请输入" clearable>
							<template slot="append">工作日</template>
						</el-input>
					</el-form-item>

					<el-form-item label="处理记录" prop="remark" v-if="dialog.type == 'check'">
						<el-input
							type="textarea"
							:rows="4"
							v-model="baseForm.remark"
							size="small"
							maxlength="1000"
							placeholder="请输入处理描述"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item label="反馈详情" v-if="dialog.type == 'view'">
						<el-input
							type="textarea"
							:rows="4"
							v-model="baseForm.remark"
							size="small"
							maxlength="1000"
							placeholder=""
							disabled
						></el-input>
					</el-form-item>
					<el-form-item label="联系人" prop="linkMan" v-if="dialog.type == 'view'">
						<el-input v-model="baseForm.linkMan" size="small" maxlength="30" placeholder="" disabled></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="phone" v-if="dialog.type == 'view'">
						<el-input v-model="baseForm.phone" size="small" maxlength="30" placeholder="" disabled></el-input>
					</el-form-item>
					<el-form-item label="其他方式" prop="otherLink" v-if="dialog.type == 'view'">
						<el-input v-model="baseForm.otherLink" size="small" maxlength="30" placeholder="" disabled></el-input>
					</el-form-item>
					<el-form-item label="上传文件" prop="file" v-if="dialog.type == 'view'">
						<newUpload
							isViewMode
							ref="update_result_file"
							listType="text"
							:viewFilesList="files"
							v-if="files.length != 0"
							class="pt8"
							width="100%"
							height="100%"
						>
						</newUpload>
						<span v-else>-</span>
					</el-form-item>
				</el-form>
			</div>
			<div v-if="activeTabIndex == 1">
				<el-table :data="tableData" height="100%" highlight-current-row row-key="id" border ref="table">
					<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
					<el-table-column prop="remark" label="处理记录" header-align="center" min-width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="status" label="处理状态" header-align="center" min-width="100" show-overflow-tooltip>
						<template slot-scope="scope">
							<span class="orange" v-if="scope.row.status == -1"> 待处理 </span>
							<span class="green" v-else-if="scope.row.status == 0">处理中</span>
							<span class="red" v-else-if="scope.row.status == 1">已解决</span>
							<span class="red" v-else-if="scope.row.status == 2">已关闭</span>
						</template>
					</el-table-column>
					<el-table-column prop="dealUser" label="处理人" header-align="center" min-width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="createDate" label="处理时间" header-align="center" min-width="150" show-overflow-tooltip></el-table-column>
				</el-table>
			</div>
		</div>
		<div slot="footer" class="text-center" v-if="dialog.type == 'check' && activeTabIndex == 0">
			<el-button type="info" class="btns" @click="dialog.visible = false" :loading="dialog.btnLoading">取消</el-button>
			<el-button type="primary" class="btns btn-red" :loading="dialog.btnLoading" @click="goSubmit">提交</el-button>
		</div>
	</el-dialog>
</template>
<script>
import * as API from '@/api/modules/feedBack'
import newUpload from '@/components/w-upload/newUpload'

export default {
	components: { newUpload },
	data() {
		return {
			status: '',
			activeTabIndex: 0,
			dialog: {
				visible: false,
				loading: false,
				type: '',
				btnLoading: false
			},
			tableData: [],
			baseForm: {
				status: '',
				remark: '',
				dealHour: '',
				id: ''
			},
			baseRules: {
				status: [{ required: true, message: '不能为空', trigger: 'blur' }],
				remark: [{ required: true, message: '不能为空', trigger: 'blur' }],
				dealHour: [
					{ required: true, message: '不能为空', trigger: 'blur' },
					{
						pattern: /^30$|^([1-2]\d)$|^\d?$/,
						message: '格式不正确,只能输入正整数 0-30',
						trigger: ['blur', 'change']
					}
				]
			},
			files: []
		}
	},
	methods: {
		//打开弹框
		open(type, row) {
			console.log(type)
			this.baseForm = {
				status: '',
				remark: '',
				dealHour: '',
				id: ''
			}
			this.dialog.visible = true
			this.activeTabIndex = 0
			this.dialog.type = type
			this.status = row.status
			this.baseForm.id = row.id
			if (type == 'view') {
				this.getDetail(row.id)
			}

			this.getPlatSuggestDealRecord(row.id)
		},
		//详情
		getDetail(id) {
			API.getPlatSuggestDetail({ id: id }).then((res) => {
				this.baseForm = res.data
				this.files = []
				res.data.files.map((item) => {
					let obj = {
						fileName: item.file_name,
						serverName: item.server_name,
						fileDirectory: item.file_directory,
						id: item.id
					}
					this.files.push(obj)
				})
			})
		},
		//tab切换
		tabChange(val) {
			this.activeTabIndex = val
		},
		//记录
		getPlatSuggestDealRecord(id) {
			API.getPlatSuggestDealRecord({ id: id }).then((res) => {
				this.tableData = res.data
			})
		},
		//提交
		goSubmit() {
			this.$refs.baseForm.validate((valid) => {
				if (valid) {
					let params = { ...this.baseForm }
					this.dialog.btnLoading = true
					API.handleSuggest(params)
						.then((res) => {
							this.dialog.visible = false
							this.dialog.btnLoading = false
							this.$message.success('操作成功')
							this.$emit('change')
						})
						.catch(() => {
							this.dialog.btnLoading = false
						})
				} else {
					this.$message.warning('请完善表单！')
					return false
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
.pt8 {
	padding-top: 8px;
}
</style>
